import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useAuth, getRoles } from "@/context/AuthContext";
import { api } from "@/lib/api";

const MODE_KEY = "ic_mode";

export default function AppShell() {
  const { user, platform, b2b } = useAuth();
  const roles = getRoles(user, platform, b2b);

  const hasCare = roles.has("therapist") || roles.has("clinician") || roles.has("care") || roles.has("care_admin") || roles.has("care_professional");
  const hasBusiness = roles.has("hr") || roles.has("hr_admin") || roles.has("manager") || roles.has("business_admin") || roles.has("org_admin") || roles.has("flm_admin");
  const availableModes = [
    ...(hasBusiness ? ["business"] : []),
    ...(hasCare ? ["care"] : []),
  ];

  const [mode, setModeState] = useState(() => {
    try {
      const stored = localStorage.getItem(MODE_KEY);
      if (stored && availableModes.includes(stored)) return stored;
    } catch {}
    return availableModes[0] || null;
  });

  const setMode = async (m) => {
    setModeState(m);
    try { localStorage.setItem(MODE_KEY, m); } catch {}
    // Best-effort remote view-as
    try {
      await api.post("/platform/view-as", { mode: m });
    } catch {}
  };

  useEffect(() => {
    if (!mode && availableModes.length) {
      setModeState(availableModes[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableModes.length]);

  return (
    <div className="min-h-screen flex bg-cream-50">
      <Sidebar roles={roles} mode={mode} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar
          mode={mode}
          setMode={setMode}
          availableModes={availableModes}
          roles={roles}
        />
        <main
          className="flex-1 min-w-0 p-6 md:p-10 overflow-x-hidden"
          data-testid="app-main"
        >
          <div className="mx-auto w-full max-w-7xl animate-fade-up">
            <Outlet context={{ mode, setMode, roles, availableModes }} />
          </div>
        </main>
      </div>
    </div>
  );
}
